import React from 'react';
function CopyVoucher({ code }) {
	const copyCode = () => {
		navigator.clipboard.writeText(code);
		const object = {
			screen: 'UTIL_COPY',
			paramOne: code,
		};
		window?.webkit?.messageHandlers?.onDeeplinkExecutedV2?.postMessage(
			JSON.stringify(object)
		);
		window?.mobile?.onDeeplinkExecutedV2(JSON.stringify(object));
	};
	return (
		<div className="CopyVoucher">
			<div className="CopyVoucher__Left">
				<div className="CopyVoucher__Left__Label">Your Voucher Code</div>
				<div className="CopyVoucher__Left__Code">{code}</div>
			</div>
			<button className="CopyVoucher__Copy" onClick={copyCode}>
				COPY
			</button>
		</div>
	);
}

export default CopyVoucher;
